// extracted by mini-css-extract-plugin
module.exports = {"search__header":"HeaderDefault_search__header__bw4lv"};